import AssetsService from "@/services/assets";
import { toListItemDateString } from "@/utils/dateUtils";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import {Stack,Box} from '@mui/material'
import classes from '../css/index.module.less'

const DepositPendingList = forwardRef(({}, ref) => {
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([
    // {sn: '1111', varietyCode: 'USDT', coin: 'TRC20', coinDisplayName: 'USDT(TRC20)', depositAddress: 'afwefwaef', amount: '1000', createTime: new Date().getTime()}
  ]);
  const {t} = useTranslation();

  useImperativeHandle(ref, () => (
    {
      loadData,
    }
  ));

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    if (loading) return;

    setLoading(true);
    try {
      // api: http://172.31.120.239:3000/project/87/interface/api/12321
      const res = await AssetsService.pendingDepositList();
      setList(res);
    } finally {
      setLoading(false);
    }
  }

  if (loading) return <div>{t('loading')}</div> 
  if (!list.length) return null;

  return <Stack direction={'column'} >
    {t('pending_deposit_list')}
    {list.map((record) => <Box className={classes['flow-list']}>
      <Stack direction={'row'} justifyContent={'space-between'}>
        <div>
          <span>{record.amount}</span>
          <span>{record.coinDisplayName}</span>
        </div>
        <span>{t('pending')}</span>
      </Stack>
      <div>{toListItemDateString(record.createTime)}</div>
    </Box>)}
  </Stack>
});

export default DepositPendingList;
